import React, { useState, SetStateAction } from "react";
import { TextField, Autocomplete, Box, createFilterOptions } from "@mui/material";
import { searchUsers } from "../services/usersApi";
import { useMsal } from '@azure/msal-react';
import { UserSearchInfo } from "../services/common";

interface ListedContactTextBoxProps {
    label: React.ReactNode;
    handleChange: React.Dispatch<SetStateAction<UserSearchInfo[]>>;
    defaultValue: UserSearchInfo[];
}

const ListedContactTextBox = ({ label, handleChange, defaultValue }: ListedContactTextBoxProps) => {
    const { instance } = useMsal();
    const slotProps = { inputLabel: { shrink: true } };
    const [searchString, setSearchString] = useState<string | null>(null);
    const [userList, setUserList] = useState(defaultValue == null || defaultValue?.length == 0 ? [{ hint: 'Type to search' }] : defaultValue);
    const onHandleChange = (e: UserSearchInfo[]) => {
        handleChange(e);
    };
    const filter = createFilterOptions<UserSearchInfo>();
    const searchUsersDelay = async (searchString: string | null) => {
        if (searchString == null || searchString === '') {
            onHandleChange(null);
            return;
        }
        if (searchString.length > 2) {
            setSearchString(searchString);
        }
    };
    const onSearchUsers = async () => {
        if (searchString === null) {
            return;
        }
        if (searchString.length > 2) {
            const searchResult = await searchUsers(instance, searchString)
            setUserList(searchResult);
        }
    };
    React.useEffect(() => {
        const timeout = setTimeout(() => { onSearchUsers() }, 1000)
        return () => clearTimeout(timeout)
    }, [searchString]);
    return (
            <Autocomplete
                multiple={true}
                freeSolo={true}
                selectOnFocus={true}
                clearOnBlur={true}
                handleHomeEndKeys={true}
                onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                        onHandleChange([{ email: newValue, isFreeTextValue: true }]);
                    } else {
                        onHandleChange(newValue as Array<UserSearchInfo>);
                    }
                }}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    const isExisting = options.some((option) => inputValue === option.email);
                    if (inputValue !== '' && !isExisting) {
                        filtered.push({
                            email: inputValue,
                            hint: `Use "${inputValue}" as owner`
                        });
                    }

                    return filtered;
                }}
                onInputChange={(e, v) => { searchUsersDelay(v); }}
                disabled={false}
                className="details-apps-autocomplete"
                value={defaultValue}
                getOptionLabel={(option) => option['name'] ?? option['email'] ?? ""}
                options={userList}
                renderOption={(props, option) => {
                    const { key, ...optionProps } = props;
                    return (
                        <Box
                            key={key + option.email}
                            component="li"
                            sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                            {...optionProps}
                        >
                            <div>
                                <div>{option.name ?? option.hint ?? option.email}</div>
                                {(!!option.email) === true ? <div style={{ fontSize: '12px' }}>({option.email})</div> : ""}
                            </div>
                        </Box>
                    );
                }}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        slotProps={slotProps}
                        className="details-apps-autocomplete-inner"
                        margin="dense"
                        label={label}
                    />
                }
            />);
};

export default ListedContactTextBox;
